import { Column } from "components/Table/Table";
import { AdvantageDemand } from "generated/graphql";
import { formatAmount, formatDate } from "utils";
import { formatAddress } from "../utils";

export const usProgramColums = (text: any): Column<AdvantageDemand>[] => {
  return [
    {
      title: text.all.advantage,
      field: "advantage",
      render: ({ advantage }) => advantage?.service?.label,
    },
    {
      title: text.all.quantity,
      field: "quantity",
      render: ({ quantity }) => quantity,
    },
    {
      title: text.all.use_date,
      field: "date",
      render: ({ date }) => formatDate(date, "dd/MM/YYYY"),
    },
    {
      title: text.all.location,
      field: "location",
      render: ({ advantage }) => formatAddress(advantage?.address),
    },
    {
      title: text.all.max_amount,
      field: "maxAmount",
      render: ({ advantage }) => `${advantage?.maxAmount}%`,
    },
  ];
};
